<template>
    <ul class="columns-block additional-products-full">
        <li class="column">
            <div class="column-block">
                <div class="d-flex align-center">
                    <span class="order-type" style="display: flex; align-items: center">
                        <span>{{ showProductType() }}</span><!-- showTypeInsurance(order) -->
                    </span>
                </div>
                <div class="bottom-part order-status">
                    <div class="bottom-block">
                        <span>Статус:</span>
                        <div>
                          <div :class="['status', getStatusClass(order)]">
                            <span>{{ showStatusName(order) }}</span>
                          </div>
                          <div v-if="!$store.getters.USER.organizationId">
                            <div v-if="checkOrderPaid(order) && (showStatusId(order) === 5 || order.typeId === 5)" class="payment-status status paid mt-1"><span>Сплачено</span></div>
                            <div v-if="!checkOrderPaid(order) && (showStatusId(order) === 5 || showStatusId(order) === 10)" class="payment-status status mt-1"><span>Не сплачено</span></div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="column">
            <div class="column-block">
            <a  class="order-number" target="_blank" :href="showMtsbuLink(order)" v-if="isDgo() && showMtsbuLink(order)">
                {{ showMtsbuCode(order) }}<br /> на основi
<!--              {{ showMtsbuCodeAdditionalInfoAlt(order) }}-->
            </a>
            <span v-else-if="showMtsbuCode(order)" class="order-number">
                {{ showMtsbuCode(order) }}
            </span>
            <span class="order-number" v-else>&mdash;</span>
            <div class="bottom-part order-user">
                <div class="bottom-block">
                    <div class="option-block">
                        <div class="option">Точка продажу:</div>
                        <div class="user-name" data-toggle="tooltip" data-placement="bottom" :title="showNameInsured(order)">
                          {{ showNameInsured(order) }}
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </li>
        <li class="column">
            <div class="column-block">
                <div>
                    <div class="date-block">
                        <div class="text">Створений:</div>
                        <span v-if="order.createdAt" class="date">{{ order.createdAt }}</span>
                        <span v-else class="date">&mdash;</span>
                    </div>
                    <div class="date-block">
                      <div class="text">Початок:</div>
                      <span v-if="showStartedAtContract(order)"
                            class="date">{{ showStartedAtContract(order) }}</span>
                      <span v-else class="date">&mdash;</span>
                    </div>
                    <div class="date-block">
                      <div class="text">Закінчення:</div>
                      <span v-if="showFinishedAtContract(order)"
                            class="date">{{ showFinishedAtContract(order) }}</span>
                      <span v-else class="date">&mdash;</span>

                    </div>
                    <div v-if="showTerminated(order)" class="date-block">
                      <div class="text">Дата ДР:</div>
                      <span
                        class="date">{{ showTerminated(order) }}</span>
                    </div>
                </div>
                <div class="bottom-part order-company">
                    <div class="bottom-block"><!-- right-border -->
                    <div class="option-block">
                        <div class="option">СК:</div>
                        <div class="result"
                             data-toggle="tooltip" data-placement="bottom"
                             :title="order.companyInfo.name">
                            <ellipsis
                              :data="order.companyInfo.name">
                            </ellipsis>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </li>
        <li class="column">
            <div class="column-block">
                <div class="order-insured">
                    <a class="dark-link" v-if="order.client_id" :href="'/clients/'+order.client_id">
                      <div v-if="showNameInsurantSurname(order)">
                        <span>{{ showNameInsurantSurname(order) }}</span>
                        <span> {{ showNameInsurantName(order) }}</span>
                        <span> {{ showNameInsurantPatronymic(order) }}</span>
                      </div>
                    </a>
                    <div v-else>
                      <div v-if="showNameInsurantSurname(order)">
                        <span>{{ showNameInsurantSurname(order) }}</span>
                        <span> {{ showNameInsurantName(order) }}</span>
                        <span> {{ showNameInsurantPatronymic(order) }}</span>
                      </div>
                    </div>
                </div>
                <div class="bottom-part order-company">
                    <div class="bottom-block">
                        <span class="result">{{ order.insuranceObject.number }}</span>
                    </div>
                </div>
            </div>
        </li>
        <li class="column">
            <div class="column-block">
                <div>
                    <div class="price-block">
                        <div class="text">Первісна:</div>
                        <span v-if="isDgo()" class="date">{{ showDgoPrice(order) }}</span>
                        <span v-else-if="isAutolawyer()" class="date">{{ showAutolawyerPrice(order) }}</span>
                    </div>
                </div>
                <div class="bottom-part">
                    <div class="bottom-part">
                        <div v-if="isConcluded(order) && order.typeId !== 2" class="show-btn">
                          <span class="option image">
                              <svg style="margin-bottom: 5px" width="16" height="16"
                                   viewBox="0 0 16 16" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0)">
                                  <path
                                    d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                    stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                                  <path
                                    d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                    stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0">
                                    <rect width="16" height="16" fill="white"/>
                                  </clipPath>
                                </defs>
                              </svg>
                          </span>
                          <a @click="goToOrderInfo(order, productType)" href="javascript:void(0);">
                              <span class="option">
                                Переглянути
                              </span>
                          </a>
                      </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="column">
            <div class="column-block">
                <div v-if="!$store.getters.USER.organizationId || $store.getters.USER.organizationType === 'head'">
                    <div class="price-block" v-if="showCrossAllEarnings(order, productType)"><!-- order.allEarnings -->
                        <div :class="['text', {'long' : showTerminated(order)}]">Загальний:</div>
                        <span class="price">{{ showCrossAllEarnings(order, productType)  }}</span><!-- order.allEarnings -->
                    </div>
                    <div class="price-block">
                        <div :class="['text', {'long' : showTerminated(order)}]">Ваш:</div>
                        <span v-if="showCrossSelfEarnings(order, productType)" class="price">{{ showCrossSelfEarnings(order, productType) }}</span><!-- order.myEarnings -->
                        <span v-else class="price">&mdash;</span>
                    </div>
                    <div class="price-block" v-if="order.isPartnerOrder">
                        <div :class="['text', {'long' : showTerminated(order)}]">Агента:</div>
                        <span v-if="showCrossPartnerEarnings(order, productType)" class="price">{{ showCrossPartnerEarnings(order, productType) }}</span><!-- order.partnerEarnings -->
                        <span v-else class="date">&mdash;</span>
                    </div>
<!--                    <div class="price-block" v-if="showTerminated(order)">-->
<!--                        <div :class="['text', {'long' : showTerminated(order)}]">Утримано за ДР:</div>-->
<!--                        <span class="price">{{ showTerminatedSum(order) }}</span>-->
<!--                    </div>-->
                </div>
                <div class="bottom-part">
                    <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                         class="option-loader spinner-border"
                         style="height: 14px; width: 14px; margin-bottom: 4px;"
                         role="status">
                    </div>
                  <!-- :order-type="order.typeId" -->
                  <!-- @download-contract="takeContract(order, 1)" -->
                    <more-options v-else :status-order="showStatusId(order)"
                                  :order="order"
                                  :order-type="productType"
                                  :data-contract-extra-files="order.contract.extraFiles"
                                  @download-draft="showCrossProductDraft(order, productType)"
                                  @download-contract="downloadDataCrossProduct(order, productType)"
                                  @show-order="goToOrderInfo(order, productType)"
                                  @proceed-order="declare(order,false,false,1)"
                                  @confirm-order="declare(order,false,false,2)"
                                  @open-mtsbu-link="openMtsbuLink(order)"
                                  @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                  @get-payment-invoice="getPaymentInvoice(order)"
                                  @get-instant-loan="getInstantLoan(order)"
                                  :is-exist-mtsbu-link="showMtsbuLink(order)"
                                  @copy-order="copy(order)">
                    </more-options>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import {ClientInfo, MoreOptions} from './../components';
import {customerMixin, HistoryMixin, orderMixin, userMixin} from '@/mixin';
import displaySettings from '@/mixin/displaySettings';

export default {
      name: 'CrossProductCard',
      components: {
        MoreOptions,
        ClientInfo,
      },
      mixins: [orderMixin, customerMixin, HistoryMixin, displaySettings, userMixin],
      directives: { ClickOutside },
      props: {
            order: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            productType: {
              type: Number,
              default: () => {
                return 4;
              }
            },
            showActsColumnStatus: {
              type: Boolean,
              default: () => {
                return false;
              }
            },
            margeActsList: {
              type: Object,
              default: () => {
                return {};
              }
            },
            listQuery: {
              type: Object,
              default: () => {
                return {};
              }
            },
            loadMoreOptions: {
              type: Object,
              default: () => {
                return {};
              }
            },
        },
        data: function () {
            return {
                condition: {
                    isShow: false,
                },
            }
        },
        computed: {
          orderTypes: function () {
            return this.$store.getters.ORDER_TYPES;
          },
        },
        methods: {
            hide: function () {
                return this.condition.isShow = false;
            },
            handle: function () {
                return this.condition.isShow = ! this.condition.isShow
            },
            aktsToggleCompact(order,$event) {
              this.$emit('acts-toggle', order,$event);
            },
            isDgo() {
                return this.productType === 4;
            },
            isAutolawyer() {
              return this.productType === 6;
            },
            showProductType() {
                const orderType = this.allOrderTypes.find(type => type.id === parseInt(this.productType));
                return orderType ? orderType.name : 'ДЦВ';
            },
        }
    }
</script>

<style lang="scss" scoped>



</style>
